/**
 * Utility functions for filtering the main list based on the group name,location,
 * modal,equipment fields 
 * @param {Array.<mainList>} - mainList -  dynamically getting passed from listBookingAccessConfigurationByEquipment new items,
 * listBookingAccessConfigurationByEquipmentModel new items for filtering
 * @param {string} searchGroup - the user seached value.
 * @param {Array.<fields>} fields - the user seached value of group name,location,modal,equipment from the list to filter.
 */

export function filterGroups(mainList, searchGroup, fields) {
  if (!searchGroup) return mainList || [];
  const searchLower = searchGroup.toLowerCase();

  return (mainList || []).filter((item) =>
    fields.some((field) => {
      const value = field(item);
      return value && value.toLowerCase().includes(searchLower);
    })
  );
}
